import store from "../app/store";
import { createAction } from "@reduxjs/toolkit";
import { ACTION_AUTH_TOKEN_CHANGED } from "./AuthReducer";
import { showDangerToast, showSuccessToast } from "../validation/ToastContainer";
import { debug, objectToUrlEncodedString } from "../utils";
import {
    AUTH_API, AUTH_SERVER_API, FILE_API, USER_API, LICENSE_API,
    USER_ROLE_API, USERROLE_CAPABILITY_API, CENTRAL_CREDENTIALS_API, SEND_MAIL_API
} from "../vars";
import { establishSecurityDialog, establishSecurityDialogs } from "./authDialogService";
import { ACTION_USERS_LOADED as USERS_LOADED_AUTH_PAGE,
    ACTION_AUTHSERVERS_LOADED as AUTHSERVERS_LOADED_AUTH_PAGE,
    ACTION_CENTRALCREDENTIALS_LOADED as CENTRALCREDENTIALS_LOADED_AUTH_PAGE
 } from "./AuthPageReducer";
//import { ACTION_AUTHSERVERS_LOADED as AUTHSERVERS_LOADED_AUTH_PAGE } from "./AuthPageReducer";
import { ACTION_USERS_LOADED as USERS_LOADED_ALERT_PAGE } from "../alert/AlertNotificationPageReducer";
import { getSortAndFilterQueryString } from "../view/urlService";

function touchSessionActivity() {
    sessionStorage.setItem('lastTimeStamp', new Date().toISOString());
}

function clearSessionActivity() {
    sessionStorage.removeItem('lastTimeStamp');
}

export function login(username, password, rememberMe) {
    return establishSecurityDialog(password, async (id, password) => {
       return fetch(`${AUTH_API}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                username: username,
                password: password,
                id: id
            })
        })
            .then(response => {
                if (!response.ok) {
                    // eslint-disable-next-line no-throw-literal
                    throw 'Invalid credentials'
                }
                return response.json();
            })
            .then(response => {               
                return response;
                //return setupNewToken(response.access_token, response.userCapability, rememberMe);
                //return setupNewToken_orig(response.access_token);
            }).catch(resp => {
                showDangerToast(
                    "Invalid credentials. Please try again",
                    "Sign in failure"
                )
            })
    })

}

export async function setupNewToken(newToken, userCapability, rememberMe) {
    // if (rememberMe) {
    //     // Save the token in LocalStorage for persistence
    //     localStorage.setItem('access_token', newToken);
    //     localStorage.setItem('userCapability', JSON.stringify(userCapability));
    //   } else {
    //     sessionStorage.setItem('access_token', newToken);
    //     sessionStorage.setItem('userCapability', JSON.stringify(userCapability));
    //   }
    //localStorage.setItem('access_token', newToken);
    sessionStorage.setItem('access_token', newToken);
    sessionStorage.setItem('userCapability', JSON.stringify(userCapability));
    touchSessionActivity();
    return loadTokenFromLocalStorage(rememberMe);
}

export async function setupUserCapabilities(access_token, userCapability, rememberMe) {
    sessionStorage.setItem('userCapability', JSON.stringify(userCapability));
    return loadTokenFromResponse(access_token, rememberMe);
}

export async function setupTokenOnly(newToken, rememberMe) {
    //localStorage.setItem('access_token', newToken);
    sessionStorage.setItem('access_token', newToken);
    touchSessionActivity();
    return loadTokenFromLocalStorage(rememberMe);
}

export async function createOTP() {
    return await securedFetch(`${AUTH_API}/otp`)
        .then(response => response.json())
}

export async function createOTP_n() {
    return await securedFetch(`${AUTH_API}/otp`);
    // if (!response.ok) {
    //     throw new Error(`Failed to create OTP: ${response.status}`);
    // }
    // return response.json();
}



export function sendOtpToMail(otp, userMail){
    return securedFetch(`${SEND_MAIL_API}/sendotp`, {
        otp,
        userMail
    }, 'POST').then(response => response.ok);
}

export function setSessionOtp(otp){
    const otp_date = Math.floor(Date.now() / 1000);
    sessionStorage.setItem('otp', otp);
    sessionStorage.setItem('otp_date', otp_date);
}


export function loadTokenFromLocalStorage(rememberMe) {
    //debug("--Token validation is being processed...")
    // let access_token;
    // if (rememberMe) {
    //     access_token = localStorage.getItem('access_token');
    //   } else {
    //     access_token = sessionStorage.getItem('access_token');
    //   }
    //const access_token = localStorage.getItem('access_token');
    const access_token = sessionStorage.getItem('access_token');
    const userCapability = JSON.parse(sessionStorage.getItem('userCapability')) || [];
    if (!!access_token) {
        return validateToken(access_token, rememberMe)
            .then((response) => {
                store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({
                    ...response,
                    access_token: access_token,
                    userCapability: userCapability
                }));
            })
            .catch((response) => {
                eraseToken();
                showDangerToast(
                    'Enter your credentials to continue',
                    `Session expired`
                )
                throw response
            });
    } else {
        store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({ access_token: null }))
        return Promise.reject();
    }
}

export function loadTokenFromLocalStorage_1() {
    debug("--Token validation is being processed...")

    //const access_token = localStorage.getItem('access_token');
    const access_token = sessionStorage.getItem('access_token');
    loadUserCapability(sessionStorage.getItem('role'))
        .then(userCapability => {
            if (!!access_token) {
                return validateToken(access_token)
                    .then((response) => {
                        store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({
                            ...response,
                            access_token: access_token,
                            userCapability: userCapability
                        }));
                    })
                    .catch((response) => {
                        eraseToken();
                        showDangerToast(
                            'Enter your credentials to continue',
                            `Session expired`
                        )
                        throw response
                    });
            } else {
                store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({ access_token: null }))
                return Promise.reject();
            }
        });

}

export function loadTokenFromResponse(access_token, rememberMe) {
    const userCapability = JSON.parse(sessionStorage.getItem('userCapability')) || [];
    if (!!access_token) {
        return validateToken(access_token, rememberMe)
            .then((response) => {
                store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({
                    ...response,
                    access_token: access_token,
                    userCapability: userCapability
                }));
            })
            .catch((response) => {
                eraseToken();
                showDangerToast(
                    'Enter your credentials to continue',
                    `Session expired`
                )
                throw response
            });
    } else {
        store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({ access_token: null }))
        return Promise.reject();
    }
}

export async function setupNewToken_orig(newToken) {
    //localStorage.setItem('access_token', newToken);
    sessionStorage.setItem('access_token', newToken);
    touchSessionActivity();
    return loadTokenFromLocalStorage_orig();
}

export function loadTokenFromLocalStorage_orig() {
    debug("--Token validation is being processed...")

    //const access_token = localStorage.getItem('access_token');
    const access_token = sessionStorage.getItem('access_token');
    if (!!access_token) {
        return validateToken(access_token)
            .then((response) => {
                store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({
                    ...response,
                    access_token: access_token
                }));
            })
            .catch((response) => {
                eraseToken();
                showDangerToast(
                    'Enter your credentials to continue',
                    `Session expired`
                )
                throw response
            });
    } else {
        store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({ access_token: null }))
        return Promise.reject();
    }
}

export async function loadUserCapability(roleId) {
    return securedFetch(`${USERROLE_CAPABILITY_API}/role/${roleId}`)
        .then(response => response.json())
        .then((userCapability) => {
            if (userCapability.error) {
                showDangerToast("Failed to load user capability!", "User Login");
            } else {
                return userCapability;
            }
        })
}



export function getUserById(id) {
    return securedFetch(`${USER_API}/profile/${id}`)
        .then(response => response.json())
        .then((user) => {
            if (user.error) {
                showDangerToast("Failed to load user", "Edit user");
            } else {
                return user;
            }
        })
}

export async function getUsersPaginated(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${USER_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(USERS_LOADED_AUTH_PAGE)({ users: data.page }));
        store.dispatch(createAction(USERS_LOADED_ALERT_PAGE)({ users: data.page }));
        return { users: data.page, totalPages: data.total, totalRecords: data.records }
    });

}

export async function applyMinorChanges(user) {
    return securedFetch(`${USER_API}/minor`, user, 'POST');
}

export function deleteUser(id) {
    return securedFetch(`${USER_API}/${id}`, null, 'DELETE').then(response => response.ok);
}

export function createUser(data) {
    // const formData = new FormData();
    // formData.append('username', data.username);
    // formData.append('firstName', data.firstName);
    // formData.append('lastName', data.lastName);
    // formData.append('image', data.image);
    // formData.append('email', data.email);
    // formData.append('type', data.userType);
    // formData.append('userRole', data.userRoleId);
    // formData.append('enableOtp', data.enableOtp);

    const userData = {
        username: data.username,
        firstName: data.firstName,
        lastName: data.lastName,
        image: data.image,
        email: data.email,
        type: data.userType,
        userRole: data.userRoleId,
        groupIds: data.groupIds || [],
        enableOtp: data.enableOtp,
      };

    return establishSecurityDialog(data.password, async (id, password) => {

        // formData.append('dialogId', id);
        // formData.append('password', password);

        userData.dialogId = id;
        userData.password = password;

        return fetch(USER_API,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getAuthHeader()
                },
                body: JSON.stringify(userData), //formData
            }).then(response => {
                response.ok ?
                    showSuccessToast(
                        "User created",
                        "New user"
                    ) : showDangerToast(
                        'Something went wrong',
                        `Error ${response.status}`
                    )
                return !!response.ok
            })
    })
}

export function updateUser_formData(data) {
    const formData = new FormData();
    formData.append('id', data.id);
    formData.append('username', data.username);
    formData.append('firstName', data.firstName);
    formData.append('lastName', data.lastName);
    formData.append('email', data.email);
    formData.append('image', data.image);
    formData.append('imageChanged', data.imageChanged);
    formData.append('passwordChanged', data.passwordChanged);
    formData.append('type', data.userType);
    formData.append('userRole', data.userRoleId);
    formData.append('enableOtp', data.enableOtp);


    if (data.passwordChanged) {
        return establishSecurityDialog(data.password, async (id, password) => {

            formData.append('dialogId', id);
            formData.append('password', password);

            return fetch(`${USER_API}/${data.id}`,
                {
                    method: 'POST',
                    headers: {
                        ...getAuthHeader()
                    },
                    body: formData
                }).then(response => {
                    response.ok ? showSuccessToast(
                        "User saved",
                        "Edit user"
                    ) : showDangerToast(
                        'Something went wrong',
                        `Error ${response.status}`
                    )
                    return !!response.ok
                })
        })
    } else {
        return fetch(`${USER_API}/${data.id}`,
            {
                method: 'POST',
                headers: {
                    ...getAuthHeader()
                },
                body: formData
            }).then(response => {
                response.ok ? showSuccessToast(
                    "User saved",
                    "Edit user"
                ) : showDangerToast(
                    'Something went wrong',
                    `Error ${response.status}`
                )
                return !!response.ok
            })
    }


}

export function updateUser(data) {
    const userData = {
        id: data.id,
        username: data.username,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        image: data.image,
        imageChanged: data.imageChanged,
        passwordChanged: data.passwordChanged,
        type: data.userType,
        userRole: data.userRoleId,
        groupIds: data.groupIds || [],
        enableOtp: data.enableOtp,
      };


    if (data.passwordChanged) {
        return establishSecurityDialog(data.password, async (id, password) => {

            userData.dialogId = id;
            userData.password = password;

            return fetch(`${USER_API}/${data.id}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...getAuthHeader()
                    },
                    body: JSON.stringify(userData),
                }).then(response => {
                    response.ok ? showSuccessToast(
                        "User saved",
                        "Edit user"
                    ) : showDangerToast(
                        'Something went wrong',
                        `Error ${response.status}`
                    )
                    return !!response.ok
                })
        })
    } else {
        return fetch(`${USER_API}/${data.id}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getAuthHeader()
                },
                body: JSON.stringify(userData),
            }).then(response => {
                response.ok ? showSuccessToast(
                    "User saved",
                    "Edit user"
                ) : showDangerToast(
                    'Something went wrong',
                    `Error ${response.status}`
                )
                return !!response.ok
            })
    }


}

export async function addToken(newToken) {
    //localStorage.setItem('access_token', newToken);
    sessionStorage.setItem('access_token', newToken);
    touchSessionActivity();
    loadTokenFromLocalStorage();
}

export async function eraseToken() {
    //localStorage.removeItem('access_token');
    sessionStorage.removeItem('access_token');
    clearSessionActivity();
    try {
        await loadTokenFromLocalStorage();
    } catch (error) {
    }    
}

export async function eraseTokenWithoutOTP() {
    //localStorage.removeItem('access_token');
    sessionStorage.removeItem('access_token');
    clearSessionActivity();
    // try {
    //     await loadTokenFromLocalStorage();
    // } catch (error) {
    // }    
}


export function getImage(fileName) {

    //const token = localStorage.getItem('access_token');
    const token = sessionStorage.getItem('access_token');

    if (token) {
        return `${FILE_API}/${fileName}?_ticket=${token}`
    }
    console.error("Failed to get auth token");
    return null;
}

export function validateToken(access_token) {
    return fetch(`${USER_API}/profile`, {
        method: 'GET',
        cache: 'no-store',
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        }
    }).then(response => {
        if (!response.ok) {
            // eslint-disable-next-line no-throw-literal
            throw 'Token expired'
        }
        return response.json();
    });
}

export function getAuthHeader() {
    //const access_token = localStorage.getItem('access_token');
    const access_token = sessionStorage.getItem('access_token');
    return { 'Authorization': `Bearer ${access_token}` }
}

/**
 * Fetch wrapper which adds the Authorization header.
 * Depending on the HTTP method puts parameters in the body or the request url
 *
 * @param url - request URL
 * @param params - data to send
 * @param method - HTTP method
 * @return {Promise<T>}
 */
export const securedFetch = (url, params, method = 'GET') => {
    // alert('authService/securedFetch')
    const options = {
        method,
        headers: {
            ...getAuthHeader(),
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        },
        cache: 'no-store'
    }

    if (params) {
        if (method === 'GET') {
            url += '?' + objectToUrlEncodedString(params);
        } else {
            options.headers = {
                ...options.headers,
                'Content-Type': 'application/json'
            }
            options.body = JSON.stringify(params);
        }
    }

    return fetch(url, options)
        .then(handleErrors)
        .catch(err => {
            console.error('Request failed', { url, method, error: err });
            showDangerToast(getFriendlyRequestErrorMessage(err), 'Request failed');
            throw err;
        });

}

function getFriendlyRequestErrorMessage(error) {
    const message = error?.message || String(error || '');
    const isDevProxyError = /proxy|ECONNREFUSED|ECONNRESET|ENOTFOUND|EHOSTUNREACH|ETIMEDOUT/i.test(message);
    const exposesInternalUrl = /(https?:\/\/|\/api\d?\/|(\d{1,3}\.){3}\d{1,3})/i.test(message);

    if (isDevProxyError || exposesInternalUrl || message === 'Failed to fetch') {
        return 'Unable to complete the request. Please verify that the service is running and try again.';
    }

    return message || 'Unable to complete the request. Please try again.';
}

async function extractErrorMessage(response) {
    const contentType = response.headers.get('content-type') || '';
    try {
        if (contentType.includes('application/json')) {
            const data = await response.json();
            return data?.message || data?.error || JSON.stringify(data);
        }
        const text = await response.text();
        return text || `Request failed with status ${response.status}`;
    } catch (error) {
        return `Request failed with status ${response.status}`;
    }
}

async function handleErrors(response) {

    if (response.status === 405) {
        await handleLicenseErrors(response);
    }

    if (response.status === 401) {
        showDangerToast(
            'Enter your credentials to continue',
            `Session expired`
        )
        //localStorage.removeItem('access_token')
        sessionStorage.removeItem('access_token')
        clearSessionActivity();
        store.dispatch(createAction(ACTION_AUTH_TOKEN_CHANGED)({ access_token: null }))

        //FIXME If the user is not redirected, the Redux will get invalid data and the React tree will break
        window.location.href = `${process.env.PUBLIC_URL || ""}/login`;

    }

    if (!response.ok) {
        const message = await extractErrorMessage(response);
        throw new Error(message);
    }

    return response;
}

export async function handleLicenseErrors(response) {
    let error = {};
    try {
        error = await response.json();
    } catch (e) {
        error = { error: 'License error', message: 'License validation failed' };
    }

    if (error.error === "Error") {
        window.location.href = "/renew-license?strlic=" + error.message;
    } else {
        showDangerToast(error.message, error.error);
    }
}

export async function uploadLicenseAfterUpgrade(license) {
    return fetch(LICENSE_API,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ license: license })
        });
}



//#region User Roles

export function listRoles() {
    return securedFetch(USER_ROLE_API)
        .then(response => response.json())
        .then(data => {
            return data;
        });

}

//#endregion



//#region Authentication Server Code
/** Authentication Servers Code part
 * DevTeam: Apr 06, 2023
 * Functions for Authentication Servers
 * 
 * 
 */

export async function getAuthServerPaginated(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${AUTH_SERVER_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(AUTHSERVERS_LOADED_AUTH_PAGE)({ authServers: data.page }));
        // store.dispatch(createAction(USERS_LOADED_ALERT_PAGE)({authServers: data.page}));
        return { authServers: data.page, totalPages: data.total, totalRecords: data.records }
    });

}

export function createAuthServer(data) {
    let newAuthServer = {
        ip: data.ip,
        baseDN: data.baseDN,
        serviceName: data.serviceName,
        password: data.passwordTxt,
        type: data.type,
        status: data.status
    }

    return securedFetch(`${AUTH_SERVER_API}`, newAuthServer, 'POST'
    ).then(async response => {
        if (response.ok) {
            showSuccessToast(
                "Authentication Server created",
                "New Authentication Server"
            );
        } else {
            response = await response.json()
            showDangerToast(response.message, "Error")
        }
        return !!response.ok
    })
}

export function updateAuthServer(data) {

    let authServer = {
        id: data.id,
        ip: data.ip,
        baseDN: data.baseDN,
        serviceName: data.serviceName,
        password: data.passwordTxt,
        type: data.type,
        status: data.status
    }

    return securedFetch(`${AUTH_SERVER_API}`, authServer, 'POST'
    ).then(async response => {
        if (response.ok) {
            showSuccessToast(
                "Authentication Server updated",
                "Authentication Server"
            );
        } else {
            response = await response.json()
            showDangerToast(response.message, "Error")
        }
        return !!response.ok
    })
}

export function getAuthServerById(id) {
    return securedFetch(`${AUTH_SERVER_API}/authserver/${id}`)
        .then(response => response.json())
        .then((authServer) => {
            if (authServer.error) {
                showDangerToast(
                    "Failed to load authentication server",
                    "Edit Authentication Server"
                );
            } else {
                return authServer;
            }
        })
}

export function deleteAuthServer(id) {
    return securedFetch(`${AUTH_SERVER_API}/${id}`, null, 'DELETE')
        .then(response => response.ok);
}

export function authenticateUserLDAP(data) {

    return securedFetch(`${AUTH_SERVER_API}/authenticate`, data, 'POST'
    ).then(async response => {
        if (response.ok) {
            const message = await response.text();
            // alert (message)
            if (message === '1') {
                showSuccessToast(
                    "Authentication is Successfull",
                    "Authentication"
                );
            } else {
                showDangerToast(
                    "Authentication is not ok!",
                    "Authentication"
                )
            }
            return message

        } else {
            response = await response.json()
            showDangerToast(response.message, "Error Authentication")
        }
        return !!response.ok
    })
}

//#endregion


//#region Central Credentials

export async function getCentralCredentialsPaginated(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${CENTRAL_CREDENTIALS_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(CENTRALCREDENTIALS_LOADED_AUTH_PAGE)({ centralCredentials: data.page }));
        return { centralCredentials: data.page, totalPages: data.total, totalRecords: data.records }
    });

}

export function getCentralCredentialsById(id) {
    return securedFetch(`${CENTRAL_CREDENTIALS_API}/centralcredential/${id}`)
        .then(response => response.json())
        .then((authServer) => {
            if (authServer.error) {
                showDangerToast(
                    "Failed to load Central Credential",
                    "Edit Central Credential"
                );
            } else {
                return authServer;
            }
        })
}

export function createCentralCredential(data) {
    let newCentralCredential = {
        ccname: data.ccname,
        username: data.username,
        password: data.password
    }

    return secureField('password', newCentralCredential)
        .then(centralCredentialWithSecuredField =>
            securedFetch(CENTRAL_CREDENTIALS_API, centralCredentialWithSecuredField, 'POST')
                .then(async response => {
                    if (response.ok) {
                        showSuccessToast(
                            "Central Credential created",
                            "New Central Credential"
                        );
                    } else {
                        response = await response.json()
                        showDangerToast(response.message, "Error")
                    }
                    return !!response.ok
                })
        )

    // return securedFetch(`${CENTRAL_CREDENTIALS_API}`, newCentralCredential, 'POST'
    // ).then(async response => {
    //     if (response.ok) {
    //         showSuccessToast(
    //             "Central Credential created",
    //             "New Central Credential"
    //         );
    //     } else {
    //         response = await response.json()
    //         showDangerToast(response.message, "Error")
    //     }
    //     return !!response.ok
    // })
}

export function updateCentralCredential(data) {

    let updatedCentralCredential = {
        id: data.id,
        ccname: data.ccname,
        username: data.username,
        password: data.password,
        passwordChanged: data.passwordChanged
    }

    if (data.passwordChanged) {
        return secureField('password', updatedCentralCredential)
        .then(centralCredentialWithSecuredField =>
            securedFetch(CENTRAL_CREDENTIALS_API, centralCredentialWithSecuredField, 'POST')
                ).then(async response => {
                    if (response.ok) {
                        showSuccessToast(
                            "Central Credential updated",
                            "Central Credential"
                        );
                    } else {
                        response = await response.json()
                        showDangerToast(response.message, "Error")
                    }
                    return !!response.ok
                })
    }
    else {
        return securedFetch(`${CENTRAL_CREDENTIALS_API}`, updatedCentralCredential, 'POST'
            ).then(async response => {
                if (response.ok) {
                    showSuccessToast(
                        "Central Credential updated",
                        "Central Credential"
                    );
                } else {
                    response = await response.json()
                    showDangerToast(response.message, "Error")
                }
                return !!response.ok
            }) 
    }
    
}

export function deleteCentralCredential(id) {
    return securedFetch(`${CENTRAL_CREDENTIALS_API}/${id}`, null, 'DELETE')
        .then(response => response.ok);
}

//#endregion




//#region General Functions
/**
 * Secure specified field of object.
 *
 * @param object {Object} - object with field to secure
 * @param fieldName {String} - key of data object field to secure
 * @returns {Promise<*>} - incoming object which includes dialogId and secured field
 */
export async function secureField(fieldName, object) {
    
    return establishSecurityDialog(object[fieldName], async (id, response) => {
        if(fieldName !== 'msClientId') 
            object[fieldName] = response;
        object.dialogId = id;
        return object;
    })
}

export async function getDialogId(fieldName, object) {
    return establishSecurityDialog(object[fieldName], async (id, response) => {
        //object[fieldName] = response;
        object.dialogId = id;
        return object;
    })
}

//Added by octopus DevTeam on March 17,2022
export async function secureFields(fieldNames, object) {
    let passedFieldNames = [];
    for (let i = 0; i < fieldNames.length; i++) {
        passedFieldNames.push(object[fieldNames[i]]);
    }
    return establishSecurityDialogs(passedFieldNames, async (id, response) => {
        object[fieldNames[0]] = response[0];
        object[fieldNames[1]] = response[1];
        object.dialogId = id;
        return object;
    })
}

//#endregion


